module.exports = __webpack_public_path__ + "img/se2.471724a6.png";